/*
 * Who is here right now, read from this module's own state.
 *
 * Presence arrives as chat's ephemeral event and lands in the chat slice (`state/reducer.ts`). The
 * surfaces that draw a person are core's — an avatar, a chip, a hover card, a sidebar row — and core
 * may not read inside a module's slice (architecture.md D21), so core owns the reader and this file is
 * what `web/src/modules/chat/index.ts` installs into it, the same shape as the navigate holder the
 * shell fills. This module's own surfaces call the hook directly; there is no reason for a chat screen
 * to ask core about chat's state.
 *
 * "offline" and "nobody knows" both answer undefined, because both draw nothing: a dot is a statement
 * that somebody is here, and there is no dot that says they are not (`core/people/Avatar.tsx`).
 */

import type { Presence } from "../../core/people/presence.ts"
import { useModel } from "../../core/store/store.ts"
import { chatSlice } from "./state/selectors.ts"

/** One person's state, or undefined for somebody offline, unknown, or nobody at all. */
export function useChatPresence(userId: number): Presence | undefined {
	return useModel((model) => {
		const state = chatSlice(model).presence[userId]
		return state === "online" || state === "away" ? state : undefined
	})
}
